<template>
    <div class="page-wrapper">
        <div class="page-section">
            <div class="cg-crumb">
                <btn-back />
                <span class="item">订单管理</span>
                <em class="gap">/</em>
                <span class="item">锁仓详情</span>
            </div>
            <div class="cg-main-title">锁仓详情</div>
            <div class="header-handle-box">
                <h3 class="state">
                    当前锁仓状态：
                    {{supplierLockOrderState[orderState]}}
                </h3>
                <div class="btns" v-if="orderState == 2">
                    <button class="cg-btn red big" @click="agreeLockOrder">同意锁仓</button>
                    <button class="cg-btn red-border big" @click="rejectLockOrder">拒绝锁仓</button>
                </div>
                <div class="tip" v-if="orderState == 4">您拒绝了本次锁单请求</div>
                <div class="tip" v-if="orderState == 3">供应商7天未操作是否同意销售商的锁仓，该锁仓订单失效。</div>
                <div class="tip" v-if="orderState == 1">待销售商下单</div>
            </div>
            <div class="basic-info mgt-40">
                <el-row>
                    <el-col :span="8">
                    <div class="line">
                        <span class="lab">锁仓订单号：</span>
                        <span class="val">{{lockDetail.order_number}}</span>
                    </div>
                    </el-col>
                    <el-col :span="8">
                    <div class="line">
                        <span class="lab">发起锁仓时间：</span>
                        <span class="val">{{lockDetail.reserve_order_submit_time}}</span>
                    </div>
                    </el-col>
                    <el-col :span="8">
                    <div class="line blue">
                        <span class="lab">锁仓时价格：</span>
                        <span class="val">{{lockDetail.item_order_price}}元/件</span>
                    </div>
                    </el-col>
                </el-row>
            </div>

            <div class="order-detail-table">
                <table class="table">
                    <tr class="th">
                        <th width="40%">商品</th>
                        <th width="20%">款号</th>
                        <th width="20%">采购方</th>
                        <th width="20%">锁仓总数</th>
                    </tr>
                    <tr>
                        <td>
                            <div class="td-1-wrap">
                                <el-image
                                    class="img"
                                    :src="goodsImgUrl"
                                    fit="cover"
                                    :preview-src-list="[goodsImgUrl]"
                                ></el-image>
                                <div class="title">{{lockDetail.item_name}}</div>
                            </div>
                        </td>
                        <td>{{lockDetail.item_style_number}}</td>
                        <td>{{lockDetail.dealerName}}</td>
                        <td>{{lockDetail.order_reserve_quantity}}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="page-section">
            <div class="cg-mod-title mgt-0">锁仓明细</div>
            <div class="take-order-table mgt-24">
                <table class="table">
                    <thead>
                        <tr class="th">
                            <th width="20%">颜色</th>
                            <th width="20%">尺码</th>
                            <th width="20%">可销售库存</th>
                            <th width="20%">锁仓数</th>
                            <th width="">锁仓小计</th>
                        </tr>
                    </thead>               
                    <tbody v-for="(p_item, p_index) in lockSizeColorArr" :key="p_index">
                        <tr v-for="(s_item, s_index) in p_item.sizeArr" :key="s_index" >
                        <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.color}}</td>
                        <td>{{s_item.name}}</td>
                        <td>
                            {{s_item.stock_current_total_quantity}}
                        </td>
                        <td>
                            {{s_item.sizelockNumber}}
                        </td>
                        <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.colorChoseTotal}}</td>
                        </tr>             
                    </tbody>
                </table>
            </div>
        </div>

        <el-dialog title="同意锁仓" width="800px" :visible.sync="lockCheckVisible">
            <div class="agree-lock-tips">请仔细确认实际库存是否足够！</div>
            <div class="take-order-table scroll">
                <table class="table min-400">
                    <thead>
                        <tr class="th">
                            <th width="20%">颜色</th>
                            <th width="20%">尺码</th>
                            <th width="20%">可销售库存</th>
                            <th width="20%">锁仓数</th>
                            <th width="">锁仓小计</th>
                        </tr>
                    </thead>               
                    <tbody v-for="(p_item, p_index) in lockSizeColorArr" :key="p_index">
                        <tr v-for="(s_item, s_index) in p_item.sizeArr" :key="s_index" >
                        <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.color}}</td>
                        <td>{{s_item.name}}</td>
                        <td>
                            {{s_item.stock_current_total_quantity}}
                        </td>
                        <td>
                            {{s_item.sizelockNumber}}
                        </td>
                        <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.colorChoseTotal}}</td>
                        </tr>             
                    </tbody>
                </table> 
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="lockCheckVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="agreeLockOrderApi" size="small">同意锁仓</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getOrderReserveInfo, updateReserverOrderState } from '../../../api/supplier'
import { supplierLockOrderState } from '../../../utils/order-state'
export default {
    data() {
        return {
            supplierLockOrderState,  // 所有锁仓订单状态值
            orderState: 'not received', // 当前订单状态值
            // 锁单订单详情
            lockDetail: {    
                dealer_user_id: '',
                item_id: '',
                item_main_image_id: '',
                item_name: '',
                item_order_price: '',
                item_style_number: '',
                item_thumbnail_image_id: '',
                order_content: '',
                order_id: '',
                order_number: '',
                order_reserve_quantity: '',
                order_state: '',
                order_submit_time: '',
                parent_order_id: '',
                productMainImageFile: '',
                supplier_user_id: '',
            },
            // 详情图片
            goodsImgUrl: '',

            // 锁仓尺码数据
            lockSizeColorArr: [],

            // 同意锁仓 确认弹框
            lockCheckVisible: false
            
        }
    },
    created () {
        this.getOrderReserveInfo()
    },
    methods: {
        // 获取锁仓单数据
        getOrderReserveInfo() {
            getOrderReserveInfo({
                // orderState: '',
                // supplierUserId: '',
                // dealerUserId: '',
                itemId: this.$route.query.itemId,
                reserveOrderNumber: this.$route.query.orderNumber
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    let detail = res.data[0]
                    this.orderState = detail.order_state
                    this.lockDetail = detail
                    this.goodsImgUrl = process.env.VUE_APP_IMG_PREV + detail.productMainImageFile

                    try {
                        let group = JSON.parse(detail.order_content)
                        let arr = group.group
                        this.lockSizeColorArr = arr || []
                        console.log(this.lockSizeColorArr)
                    } catch (error) {
                        console.log(error)
                        this.lockSizeColorArr = []
                    }
                }
            }).catch(err => {
                console.log(err)
            })
        },
        
        // 同意锁仓
        agreeLockOrder() {
            this.lockCheckVisible = true
        },
        agreeLockOrderApi() {
            updateReserverOrderState({
                orderId: this.lockDetail.order_id,
                reserveOrderNumber: this.lockDetail.order_number,
                orderState: 1
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    this.lockCheckVisible = false
                    this.$message({
                        type: 'success',
                        message: '同意锁仓成功!'
                    })
                    this.getOrderReserveInfo()
                } else {
                    this.$message({
                        type: 'error',
                        message: res.errorMsg || '操作异常!'
                    })
                }
                
            }).catch(err => {
                console.log(err)
            })
        },
        // 拒绝锁单
        rejectLockOrder() {
            this.$prompt('请输入拒绝理由，非必填', '拒绝锁仓', {
                confirmButtonText: '拒绝锁仓',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                updateReserverOrderState({
                    orderId: this.lockDetail.order_id,
                    reserveOrderNumber: this.lockDetail.order_number,
                    orderState: 4,
                    orderLastUpdateMemo: value
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        this.$message({
                            type: 'success',
                            message: '拒绝锁仓成功!'
                        })
                        this.getOrderReserveInfo()
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.errorMsg || '操作异常!'
                        })
                    }
                }).catch(err => {
                    console.log(err)
                })
            })
        },
        // 跳转清算页面
        toLiquidation () {
            this.$router.push('/supplier/order/liquidation?orderId=' + this.orderDetail.lOrderId)
        }
    }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
    min-width: 1030px;
}
.test-btns {
    position:absolute; right: 10px; top: 10px;
}
.page-section {
    padding: 24px 24px;
    background: #fff;
    margin-bottom: 16px;
}
.header-handle-box {
    min-width: 980px;
    box-sizing: border-box;
    margin-top: 24px;
    border: 1px solid #e6e6e6;
    background: #fafafa;
    padding: 40px 80px;
    .state {
        font-size: 20px;
        color: #333;
        font-weight: 500;
        &.red {color: #F81D22;}
    }
    .btns {
        margin-top: 40px;
        .cg-btn {margin-right: 20px;}
    }
    .tip {
        margin-top: 14px;
        height:20px;
        font-size:14px;
        color:rgba(51,51,51,0.6);
        line-height:20px;
    }
    .tip-small {
        margin-left: 8px;
        height:20px;
        font-size:14px;
        color:rgba(51,51,51,0.6);
        font-size: normal;
        line-height:20px;
    }
}
.basic-info {
    &.mgt-24 {
        margin-top: 24px;
    }
    &.mgt-40 {
        margin-top: 40px;
    }
    .line {
      padding-bottom: 16px;
      font-size:14px;
      line-height:22px;
      .lab {
        color:rgba(0,0,0,0.85);
      }
      .val {
        color:rgba(0,0,0,0.65);
      }
      &.blue .lab , &.blue .val { color: #1890FF}
      .green { color: #52C41A;}
      .text-btn {
          margin-left: 16px;
          background: transparent;
          border: none;
          font-size: 14px;
          color: #1890FF;
          outline: none;
          cursor: pointer;
          &:hover {
              text-decoration: underline;
          }
      }
    }
}
.order-detail-table {
    margin-top: 24px;
    .table {
        border: 1px solid #E6E6E6;
        width: 100%;
        min-width: 980px;
        border-spacing: 0;
        border-collapse: collapse;
        font-size:14px;
        tr.th {
            background: #fafafa;
            height: 55px;
        }
        tr th {
            color:rgba(0,0,0,0.85);
            font-weight: normal;
        }
        td {
            padding: 32px 24px 0;
            color:rgba(0,0,0,0.85);
            text-align: center;
            vertical-align: top;
        }
        tr:last-child td {
            padding-bottom: 32px;
        }
        .td-1-wrap {
            height: 100px;
            .img {
                border: 1px solid #f0f0f0;
                float: left;
                width: 100px;
                height: 100px;
                margin-right: 24px;
            }
            .title {
                text-align: left;
            }
        }
    }
    .rate-info {
        margin-top: 15px;
    }
}
.goods-size-list {
    border: 1px solid #E6E6E6;
    border-top: none;
    &.mgt-24 {
        margin-top: 24px;
    }
    .color-list {
        .color-head {
            color:rgba(0,0,0,0.85);
            font-weight: normal;
            height: 50px;
            padding: 0 80px 0 48px;
            line-height: 50px;
            border-bottom: 1px solid #E6E6E6;
            border-top: 1px solid #E6E6E6;
            background: #fafafa;
            .t1 {float: left; width: 300px;}
            .t2 {float: left;}
        }
        .size-wrap {
            padding: 24px 24px 0 48px;
        }
        .size-list {
            th, td {
                width: 100px;
                padding: 0 0 24px 0;
                font-size: 14px;
                color:rgba(0,0,0,0.85);
            }
            th {
                text-align: left;
                font-weight: normal;
            }
        }
    }
}

.agree-lock-tips {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    padding-bottom: 10px;
}
.take-order-table {
  &.scroll {
      height: 50vh;
      overflow-y: auto;
      overflow-x: visible;
  }
  .table {
    border: 1px solid #E6E6E6;
    width: 100%;
    min-width: 980px;
    border-spacing: 0;
    border-collapse: collapse;
    font-size:14px;
    tr {
      height: 50px;
    }
    tr.th {
      background: #fafafa;
    }
    tr th {
      color:rgba(0,0,0,0.85);
      font-weight: normal;
    }
    td {
      border: 1px solid #E6E6E6;
      text-align: center;
      color:rgba(0,0,0,0.85);
    }
    &.min-400 {
        min-width: 400px;
    }
  }
  &.mgt-24 {
      margin-top: 24px;
  }
  &.clearing {
      margin-top: 24px;
  }
  &.clearing tr th {
    border: 1px solid #E6E6E6;
  }
  &.clearing tr th:last-child, &.clearing tr td:last-child{
    color: #F81D22;
  }
  
}

.gap-line {
    margin: 40px 0;
    height: 1px;
    background: #E6E6E6;
}

.time-line {
  margin-top: 24px;
  list-style: none;
  .item {
    position: relative;
    .item-tail {
      position: absolute;
      top: 6px;
      left: 4px;
      width: 2px;
      height: 100%;
      background: #f7f7f7;
    }
    .item-node {
      position: absolute;
      top: 6px;
      left: 0;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #d9d9d9;
    }
    &:first-child .item-node {
      background: #2a2e3f;
    }
    &:last-child .item-tail {
      width: 0;
    }
    .item-content {
      padding-left: 32px;
      font-size: 14px;
      font-weight: 500;
      width: 800px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
      padding-bottom: 16px;
    }
    .item-tit {
      padding-bottom: 8px;
      .item-tit-strong {
          font-size: 14px;
          color: #000;
          font-weight: bold;
      }
      .item-tit-during {
          font-size: 13px;
          color: #000;
      }
    }
    .item-sum-data {
        background: rgba(5, 4, 4, 0.02);
        padding: 16px 24px;
        position: relative;
        &::after {
            content: ' ';
            height: 1px;
            border-bottom: 1px dashed #ccc;
            position: absolute;
            left: 24px;
            right: 24px;
            bottom: 0;
        }
    }
    .item-box {
      background: rgba(5, 4, 4, 0.02);
      border-radius: 2px;
      padding: 24px;
      .img {
        width: 100px; height: 100px; border: 1px solid #eee;
        vertical-align: top; margin-right: 4px;
      }
      .pay-info {
        display: inline-block;
        width: 400px;
        margin-left: 10px;
        font-size: 13px;
      }
      .pdb-12 {
        padding-bottom: 12px;
      }
      .pdb-6 {
        padding-bottom: 6px;
      }
      .grey {
        color: rgba(0, 0, 0, 0.45);
      }
      .green {
        color: #52c41a;
      }
      .blue {
        color: #1890ff;
      }
    }
  }
  .sub-time-line {
    list-style: none;
    .sub-item {
      position: relative;
      padding-left: 24px;
      .title {
        display: inline-block;
        width: 450px;
      }
      .time {font-size: 13px; color: #000; margin-right: 6px;}
      &::before {
        content: " ";
        position: absolute;
        top: 15px;
        left: 3px;
        width: 1px;
        height: calc(100% - 12px);
        background: #d8d8d8;
      }
      &::after {
        content: " ";
        position: absolute;
        top: 6px;
        left: 0;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #fff;
        border: 1px solid #d8d8d8;
        box-sizing: border-box;
      }
      &:first-child::after {
        background: #ff9c6e;
        border: 1px solid #ff9c6e;
      }
      &:last-child::before {
        width: 0;
      }
    }
  }
}

.address-wrap {
    padding-top: 16px;
}
.address-label {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    line-height: 30px;
}
.address-content {
    padding: 6px 0px ;
    color: #333;
    font-size: 13px;
    .line {
        margin-bottom: 6px;
        &:last-child {margin-bottom: 0;}
    }
    .gap {
        margin-left: 30px;
    }
}

</style>